import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';

import { Flipper, Front, Back } from '../Flipper';
import Trend from 'components/Trend';
import Suggest from 'components/Suggest';
import Sparkline from 'components/Sparkline';

import { trendClass, trendIcon } from 'utils/trend';
import formatNumber from 'utils/formatNumber';
import decimalPlaces from 'utils/decimalPlaces';
const { bool, func, object } = PropTypes;

export default class Instrument extends React.Component {
  static propTypes = {
    item: object.isRequired,
    handleSelect: func.isRequired,
    edit: bool,
  };

  static defaultProps = {
    edit: false,
  };

  constructor(props) {
    super(props);
    this.handleSelect = this.handleSelect.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSelect(e) {
    e.preventDefault();
  }

  handleSubmit(e) {
    e.preventDefault();
  }

  render() {
    const {
      edit,
      item,
      handleSelect,
      className,
      handleMoveLeft,
      handleMoveRight,
      handleDelete,
    } = this.props;

    const {
      ITEM_SECTOR,
      ITEM,
      SHORT_NAME,
      LONG_NAME,
      LAST,
      CHANGE_PCT,
    } = item.values;
    const inputId = `edit-item-${ITEM_SECTOR}`;
    const lastId = `OverviewChart_LAST_${item.key}`;
    return (
      <li className={classNames('Instrument', className)}>
        <Flipper flipped={!!edit || false}>
          <Front>
            <button
              aria-label={`Select ${LONG_NAME}`}
              role="navigation"
              onClick={handleSelect}
            >
              <h3>{SHORT_NAME || ITEM}</h3>
              {/* TODO just pass CLOSE */}
              <Sparkline itemSector={ITEM_SECTOR} item={item} />

              <div className="last">
                <label htmlFor={lastId}>Siste</label>
                <Trend value={LAST}>
                  <span id={lastId}>
                    {formatNumber(LAST, decimalPlaces(LAST))}
                  </span>
                </Trend>
              </div>

              <div className="change">
                <i
                  className={classNames(
                    trendClass(CHANGE_PCT),
                    trendIcon(CHANGE_PCT),
                  )}
                />
                <Trend value={CHANGE_PCT}>{formatNumber(CHANGE_PCT)}%</Trend>
              </div>
            </button>
          </Front>
          <Back>
            <form onSubmit={this.handleSubmit}>
              <label htmlFor={inputId}>Navn</label>
              <Suggest
                aria-label="Navn"
                id={inputId}
                placeholder={ITEM_SECTOR}
                onSelect={this.handleSelect}
              />
            </form>
            <button aria-label="Move left" onClick={handleMoveLeft}>
              <i className="hb-angle-big-left" />
            </button>
            <button aria-label="Remove" onClick={handleDelete}>
              <i className="hb-cancel-rounded" />
            </button>
            <button aria-label="Move right" onClick={handleMoveRight}>
              <i className="hb-angle-big-right" />
            </button>
          </Back>
        </Flipper>
      </li>
    );
  }
}
